import React, { useState, useEffect, useRef } from 'react';
import API from '../library/ApiManager'
import Fnc from '../library/Functions'
import InlineFieldLoader from './InlineFieldLoader';

function EmailInp(props) {

  const [loading, setLoading] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailValue, setEmailValue] = useState(props.email || '');
  const emailDirty = useRef(false);
  const validationSequence = useRef(0);

  //const [, updateState] = React.useState();
  //const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    // Consente il popolamento asincrono dei dati cliente, ma non sovrascrive
    // mai quanto digitato dall'utente dopo il primo intervento sul campo.
    if (!emailDirty.current) setEmailValue(props.email || '');
  }, [props.email]);

  function onChange(e) {
    const val = e.target.value;

    emailDirty.current = true;
    validationSequence.current += 1;
    setEmailValue(val);
    setEmailVerified(false);
    setLoading(false);
    setShowError(false);
    setErrorMsg(null);

    // Il testo resta nello stato locale, mentre la form perde subito
    // l'eventuale email precedentemente verificata.
    props.callback(new Fnc.Ret(Fnc.EnmEmail.KO));
  }

  function onBlur(e) {
    let val = e.target.value;

    if (props.required) {
      //è un campo obbligatorio?

      if (val && val.length > 0) {
        //non ho un valore vuoto

        if (emailVerified !== val) {
          //non è un valore che ho già controllato

          setEmailVerified(null); //resetto valori precedenti

          if (Fnc.validateEmail(val) === Fnc.EnmEmail.OK) {
            //email formalmente valida?

            const currentValidation = ++validationSequence.current;
            setLoading(true);
            if (props.callbackIsWorking) props.callbackIsWorking();

            //-----
            API.verifyEmail(val, (data) => {
              if (currentValidation !== validationSequence.current) return;

              if (data) {
                setEmailVerified(data.email);
                if (data && data.response && data.response.code === 'OK') {
                  setShowError(false);
                  setErrorMsg(null);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.OK, data.email));
                } else if (data && data.response && data.response.code === 'KO' && data.response.message === 'Email already associated to an existing customer') {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmEmail.NOTFREE.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.NOTFREE));
                } else {
                  setShowError(true);
                  setErrorMsg(Fnc.EnmEmail.KO.msg);
                  props.callback(new Fnc.Ret(Fnc.EnmEmail.KO));
                }
              } else {
                setEmailVerified(null);
                setShowError(true);
                setErrorMsg(Fnc.EnmEmail.SERVER_DOWN.msg);
                props.callback(new Fnc.Ret(Fnc.EnmEmail.SERVER_DOWN));
              }
              setLoading(false);

            });

          } else {
            setEmailVerified(null);
            setShowError(true);
            setErrorMsg(Fnc.EnmEmail.KO.msg);
            props.callback(new Fnc.Ret(Fnc.EnmEmail.KO));
          }

        }

      } else {
        setShowError(true);
        setErrorMsg(Fnc.EnmEmail.EMPTY.msg);
        props.callback(new Fnc.Ret(Fnc.EnmEmail.EMPTY));
        setEmailVerified(null);
      }
      
    } else {
      setShowError(false);
      setErrorMsg(null);
      props.callback(new Fnc.Ret(Fnc.EnmEmail.OK, null));
    }

  }


  return (
    <>
      <input className={`form-control ${props.isLogged ? "disabled" : ""} ${showError ? "iol-field--error" : ""}`} type="email" autoComplete="email" placeholder="Es. nome@azienda.it" disabled={props.isLogged} value={emailValue} onChange={onChange} onBlur={onBlur} aria-invalid={showError}></input>
      <span className={`placeholder-text ${showError && "lblError"} `}>
        {props.required && <span className="checkout-required-marker" aria-hidden="true">*</span>} Email
      </span>
      <InlineFieldLoader visible={loading} label="Verifica email in corso" />
      {showError && <div className="iol-error-label">{errorMsg}</div>}
    </>
  );
}

export default EmailInp;
